<!-- casino-cards-swiper.svelte -->
<script lang="ts">import { getTopSectionCards } from "./data";
import { stateFeatureSet, stateTheme } from "@infinitro/config";
import { loggedIn, refreshRaces, stateDepositBonusOffers, stateRaces } from "@infinitro/global";
import { onDestroy, onMount } from "svelte";
import { derived } from "svelte/store";
import UnifiedCasinoCard from "./parts/casino-top-section/unified-casino-card.svelte";
export let onReady;
const visibleCardsStore = derived([
	stateFeatureSet,
	stateDepositBonusOffers,
	stateRaces
], ([$featureSet, $offers, $races]) => {
	const depositBonusAvailable = ($offers?.length ?? 0) > 0;
	return getTopSectionCards($featureSet, depositBonusAvailable, $races, $loggedIn, $stateTheme);
});
let visibleCards = [];
const unsubscribe = visibleCardsStore.subscribe((value) => {
	visibleCards = value;
	if (onReady) onReady(value.length);
});
onMount(() => {
	if (onReady) onReady(visibleCards.length);
	refreshRaces();
});
onDestroy(() => unsubscribe());
</script>

{#each visibleCards as card, i (`${card.id}-${i}`)}
	<div class="swiper-slide">
		<div class="slide-ratio">
			<div class="ratio-content">
				<UnifiedCasinoCard config={card} />
			</div>
		</div>
	</div>
{/each}

<style>
	:global(.top-cards-swiper .swiper-slide) {
		height: auto !important;
		display: flex;
	}
	:global(.top-cards-swiper .swiper-slide > .slide-ratio) {
		width: 100%;
	}
	.slide-ratio {
		position: relative;
		width: 100%;
	}
	.slide-ratio::before {
		content: '';
		display: block;
		padding-top: 53.3333%;
	}
	.ratio-content {
		position: absolute;
		inset: 0;
		display: flex;
		overflow: hidden;
	}

	:global(.top-cards-swiper .casino-top-card) {
		height: 100%;
		aspect-ratio: auto;
		min-height: unset;
		max-height: unset;
	}
</style>
